import Icon from '@/Icon';
import { clc } from '@/legacy/components/base/utils';
import styles from '@/legacy/components/new/styles.module.scss';

type Props = {
	className: string;
};
/** svg 임 */
const Private = ({ className }: Props) => {
	return (
		<div className={clc(styles.private, className)}>
			<Icon color1={'#FDFDFE'} path="Action_Exclude_24_White" />
		</div>
	);
};

export default Private;
